import "./Header.css";
const Header = () => {
  return (
    <header className="header">
      <h1>Todo</h1>
    </header>
  );
};

export default Header;
